<!-- <div class="kt-subheader kt-grid__item" id="kt_subheader">
	<div class="kt-subheader__main">
		<h3 class="kt-subheader__title ng-star-inserted">Request for Quotes</h3>
		<h4 class="kt-subheader__desc ng-star-inserted">List of product quotes for quotation.</h4>
	</div>
</div> -->

<div class="kt-portlet kt-portlet--responsive-mobile">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <span class="kt-portlet__head-icon">
        <i class="fas fa-comments"></i>
      </span>
      <h3 class="kt-portlet__head-title">
        {{ pageTitle }}
      </h3>
    </div>
    <div class="kt-portlet__head-toolbar">
      <button
        class="btn btn-default"
        (click)="showFilter = !showFilter"
        [translate]="'BUTTONS.FILTER'"
      >
        <i class="fas fa-filter"></i> Filter
      </button>
    </div>
  </div>

  <div class="kt-portlet__body">
    <div *ngIf="showFilter" class="kt-widget filter mb-5">
      <div class="form-group">
        <label for="">Product</label>
        <input
          type="text"
          class="form-control"
          (keyup.enter)="getRecords(false, 1)"
          [(ngModel)]="filter.product"
        />
      </div>
      <div class="form-group">
        <label for="">Client</label>
        <input
          type="text"
          class="form-control"
          (keyup.enter)="getRecords(false, 1)"
          [(ngModel)]="filter.client"
        />
      </div>
      <div class="form-group">
        <label for="">Date</label>
        <input
          type="date"
          class="form-control"
          (keyup.enter)="getRecords(false, 1)"
          [(ngModel)]="filter.date"
        />
      </div>
      <div class="form-group">
        <label for="">&nbsp;</label> <br />
        <button
          class="btn btn-outline-primary"
          (click)="getRecords(false, 1)"
          type="button"
        >
          <i class="fas fa-search"></i> </button
        >&nbsp;
        <button class="btn btn-default" (click)="filter = {}; getRecords(false, 1)">
          <i class="fas fa-eraser"></i>
        </button>
      </div>
    </div>

    <h6
      [translate]="'GENERAL.GETTING_RECORDS'"
      class="text-center mb-5"
      *ngIf="loading"
    >
      <i class="fas fa-spinner fa-spin mr-2"></i> Getting records...
    </h6>

    <div class="kt-widget" *ngIf="cRecord">
      <div class="kt-widget__item" *ngFor="let msg of cRecord.data; let i = index">
        <div class="kt-widget__content">
          <div class="kt-widget__title text-capitalize">
            <a
              [routerLink]="['/quotes', msg.rfq.id, 'view']"
              [queryParams]="{ v: 'messages' }"
              routerLinkActive="router-link-active"
            >
              <span>
                {{ msg.comment | slice: 0 : 200 }}
                <span *ngIf="msg.comment.length > 200">...</span>
              </span>
            </a>
          </div>
          <div class="kt-widget__desc">
            <small class="mr-2">Product: </small>
            <span class="text-capitalize">
              <b> {{ msg.rfq.product_name }} </b></span
            >

            <small class="ml-5" *ngIf="msg.rfq.user_account">From: </small>
            <span class="text-capitalize" *ngIf="msg.rfq.user_account">
              <b>
                {{
                  msg.rfq.user_account.firstname +
                    ' ' +
                    msg.rfq.user_account.lastname
                }}
              </b></span
            >

            <small class="ml-5 mr-2">Sent: </small>
            <span>{{ msg.created_at | date: 'mediumDate' }}</span>
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      [length]="cRecord.total"
      [pageSize]="cRecord.per_page"
      [pageSizeOptions]="pageSizeOptions"
      (page)="getRecords($event)"
    >
    </mat-paginator>
  </div>
</div>
